import IconUserIconsmall from "../SvgIcons/IconUserIconsmall";

const Avatar = ({
  name = "User",
  width = 30,
  height = 30,
  fontSize,
  className = "",
}) => {
  return (
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center text-white fw-bold ${className}`}
      style={{
        width,
        height,
        fontSize: fontSize || Math.min(width, height) / 1.9,
        flexShrink: 0,
        opacity: 0.4,
      }}
      title={name}
    >
      <IconUserIconsmall />
    </div>
  );
};

export default Avatar;
